import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { AppColorPipe } from './app-color.pipe';

@NgModule({
  declarations: [AppColorPipe],
  imports: [CommonModule],
  exports: [AppColorPipe],
})
export class AppColorPipeModule {}
